export default __webpack_public_path__ + "media/images/icon_notifications-34db240c01edf35668e9628116a0e893.png";